var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};

/*
* A function that takes a dataflow structure and returns the default Table Layout
* props. See SDMXTable in 'dotstatsuite-ui-components'. This layout is taken from
* specific dataflow level annotations.
*
* @memberOf SDMXJS
* @api public
* @tag parsing
* @tag structure
* @param {Object}
* @return {Object}
*
* @example
*
* const structure = {
*   data: { dataflows: [{
*     annotations: [
*       { title: 'DIM1,DIM3', type: 'LAYOUT_ROW'},
*       { title: 'DIM2', type: 'LAYOUT_COLUMN'},
*       { title: 'DIM5', type: 'LAYOUT_ROW_SECTION' },
*       { title: 'DIM4', type: 'LAYOUT_ROW'},
*     ]
*   }] }
* };
*
* SDMXJS.getDefaultTableLayout(structure);
* //=>{
* //    header: ['DIM2'],
* //    rows: ['DIM1', 'DIM3', 'DIM4'],
* //    sections: ['DIM5']
* //  }
*/
import * as R from 'ramda';
import { DATAFLOW_ANNOTATIONS_PATH, LAYOUT_ANNOTATIONS_TYPES, LAYOUT_KEYS } from './constants/annotations';
export var getDefaultTableLayout = function getDefaultTableLayout(structure) {
  return R.pipe(R.pathOr([], DATAFLOW_ANNOTATIONS_PATH), R.reduce(function (acc, annotation) {
    var _extends2;
    if (!R.contains(annotation.type, LAYOUT_ANNOTATIONS_TYPES)) {
      return acc;
    }
    var ids = R.pipe(R.propOr('', 'title'), R.split(','))(annotation);
    var layoutKey = R.prop(annotation.type, LAYOUT_KEYS);
    var currentIds = R.propOr([], layoutKey, acc);
    return _extends({}, acc, (_extends2 = {}, _extends2[layoutKey] = [].concat(currentIds, ids), _extends2));
  }, {}))(structure);
};